/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { LegacySalesSubmittal } from '@centecomm/portal-service';
import { createSelector } from 'reselect';
import { State, StateRecord } from '../../Types';
import { months } from '../../utils';
import { Occupant } from './Types';
import { SalesState } from './Types/SalesState';

const salesState = ({ sales }: State) => sales;

// Occupants
export const salesOccupants = createSelector(salesState, ({ occupants }: SalesState): StateRecord<Occupant> => occupants);

export const salesOccupantsList = createSelector(
    salesOccupants,
    ({ loadStatus, sortOrder, ...occupants }: StateRecord<Occupant>): Occupant[] =>
        sortOrder?.map((id) => occupants[id]) || [],
);

export const salesOccupantsLoadStatus = createSelector(
    salesOccupants,
    ({ loadStatus }: StateRecord<Occupant>) => loadStatus,
);

export const salesOccupant = (occupantId) =>
    createSelector(salesOccupants, (occupants: StateRecord<Occupant>) => occupants[occupantId] || {});

export const hasSingleSalesOccupant = createSelector(salesOccupantsList, (occupants) => occupants.length === 1);

// Sales Submittals
export const salesSubmittals = createSelector(salesState, ({ submittals }: SalesState) => submittals);

export const loadedOccupants = createSelector(salesState, ({ occupantSalesLoaded }: SalesState) => occupantSalesLoaded);

export const salesForOccupant = (occupantId: number | string) =>
    createSelector(salesSubmittals, (submittals: Record<number, LegacySalesSubmittal[]>) => submittals[occupantId] || []);

export const occupantSalesByMonth = (occupantId: number | string, year: number) =>
    createSelector(salesSubmittals, (submittals: Record<number, LegacySalesSubmittal[]>) => {
        const occupantSubmittals: LegacySalesSubmittal[] = submittals[occupantId] || [];

        return Object.keys(months).map((m: string) => {
            const submittal = occupantSubmittals.find((s) => s.year === year && s.month === +m);

            return submittal ? { submittal, month: m } : { month: m };
        });
    });

export const salesForOccupantAreLoaded = (occupantId: number | string) =>
    createSelector(salesSubmittals, (submittals: Record<number, LegacySalesSubmittal[]>) =>
        Object.prototype.hasOwnProperty.call(submittals, occupantId),
    );

export const salesSubmittal = (occupantId: number | string, month: number | string, year: number | string) =>
    createSelector(salesSubmittals, (submittals: Record<number, LegacySalesSubmittal[]>) => {
        const m = typeof month === 'string' ? +month : month;
        const y = typeof year === 'string' ? +year : year;

        return submittals[occupantId]?.find((s: LegacySalesSubmittal) => s.month === m && s.year === y);
    });

export const salesSubmissionById = (occupantId: number, salesSubmissionId: number) =>
    createSelector(salesSubmittals, (submittals: Record<number, LegacySalesSubmittal[]>) =>
        submittals[occupantId]?.find((s) => s.salesSubmissionId === salesSubmissionId),
    );
